import React, { useState, useRef, useEffect } from "react";
import dotsVertical from "../../../assets/icons/dots-vertical.svg";

function useClickOutside(ref, handler) {
    useEffect(() => {
        function handleClick(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, [ref, handler]);
}

export default function ActionsMenu({ actions }) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);

    useClickOutside(menuRef, () => setOpen(false));

    function handleMenuClick(e) {
        e.stopPropagation();
        setOpen((prev) => !prev);
    }

    function handleActionClick(action) {
        setOpen(false);
        action.onClick();
    }

    return (
        <div style={{ position: "relative", display: "inline-block" }} ref={menuRef}>
            <button
                onClick={handleMenuClick}
                style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                }}
                aria-label="Actions"
                type="button"
            >
                <img src={dotsVertical} alt="Actions" width={20} height={20} />
            </button>
            {open && (
                <div
                    style={{
                        position: "absolute",
                        right: 0,
                        top: "100%",
                        background: "#fff",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        borderRadius: 4,
                        zIndex: 1000,
                        minWidth: 120,
                    }}
                >
                    {actions.map((action) => (
                        <div
                            key={action.label}
                            onClick={() => handleActionClick(action)}
                            style={{
                                padding: "8px 16px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                                fontSize: 14,
                                color: "#333",
                                background: "none",
                            }}
                            onMouseDown={e => e.preventDefault()}
                        >
                            {action.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}